import React, { useState } from "react";
import { Upload, Table, Spin, Input, Tabs, Form, Button, Space, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { apiCall } from "../utils/Api";
import { MenuOutlined } from '@ant-design/icons';
import DragTable from "./DragTable";
import { useSession } from "../utils/Session";
import Overlay from "../util_components/Overlay";
import ListAddReplace from "./ListAddReplace";
import { filterUnique } from "../utils/Utils";


export default function ListUpload(props) {


    const { candelete = false, drag = false, resetSort = () => { }, updateRow = () => { }, setCanSave = () => { }, canSave = true, list_id, isbns, updateList = () => { } } = props;
    const [position, setPosition] = useState("list");
    const [uploading, setUploading] = useState(false);
    const [file, setFile] = useState({});
    const [processed, setProcessed] = useState(isbns);
    const [session, setSession] = useSession();
    const hasPermission = (session.has_bm_data_full || session.has_bm_data_lite);
    const [loading, setLoading] = useState(false);

    const limit = 100;

    const [form] = Form.useForm();

    const uploadFile = (_file, show_list = true, _add = true) => {
        setUploading(true);
        setFile(_file);
        apiCall("titlelist/importFile", { file: _file.file, list_id: list_id }, (_status, _result) => {
            if (_status) {
                let _arr
                if (_add) {
                    _arr = filterUnique(_result.result.titles.concat(processed), "isbn");
                } else {
                    _arr = _result.result.titles;
                }
                

                setProcessed(_arr);
                form.setFieldsValue({ txt: drawText(_arr) })
                if (show_list) {
                    setPosition("list");
                }
                updateList(_arr.map(item => { return item.isbn }));
            } else {
                setPosition("error");
            }
            setUploading(false);
            setCanSave(true);

        }, "customer");
    }

    const placeholder = "Type or paste ISBNs, EANs, or UPCs here. By default the contents will be listed in the order they are inputed, unless otherwise specified in the 'sort by' section below. \n\nexample: \n9780062351357 \n9780062304087 \n9780062063625";


    const removeItem = (f) => {


        if (!hasPermission) {
            setLoading(true);
            apiCall("titlelist/removeIsbn", { eisbn: f.eisbn, list_id: list_id }, (_s, _r) => {
                if (_s) {
                    updateRow(_r);
                    setProcessed(_r.isbns);
                } else {
                    message.error(_r.error);
                }
                setLoading(false);
            })

            return;
        }

        let m = [...processed];
        let _index = m.findIndex(item => item.eisbn === f.eisbn);
        if (_index > -1) {
            m.splice(_index, 1);
            setProcessed(m);
            if (hasPermission) {
                updateList(m.map(item => { return item.isbn }));
            } else {
                updateList(m.map(item => { return item.eisbn }));
            }

        }
    }


    const columns = [
        {
            title: <small></small>,
            dataIndex: 'eisbn',
            key: 'eisbn',
            width: 50,
            render: (e) => {
                return <div style={{ "height": "34px" }}><img className="lightshadow" onError={(e) => e.target.src = "https://bookmanager.com/i/nocover.png"} style={{ "maxHeight": "34px", "maxWidth": "30px" }} src={"https://bookmanager.com/i/slider_23.php?b=" + e} /></div>
            }
        }
    ];

    if (hasPermission) {
        columns.push({
            title: <small>ISBN</small>,
            dataIndex: 'isbn',
            key: 'isbn',
            width: 150
        })
    }

    columns.push({
        title: <small>Title</small>,
        dataIndex: 'title',
        key: 'title',
    })

    if (hasPermission && drag && (processed.length <= limit)) {
        columns.unshift(
            {
                title: <small></small>,
                dataIndex: 'success',
                width: "40px",
                key: 'success',
                render: (e) => {
                    return <div style={{ "textAlign": "center" }}><MenuOutlined style={{ "cursor": "move" }} /></div>
                }
            }
        )
    }

    if (candelete) {
        columns.push(
            {
                title: <small></small>,
                dataIndex: 'success',
                width: "80px",
                key: 'success',
                render: (e, f) => {
                    return <div><Button onClick={() => removeItem(f)} danger size="small"><small>Remove</small></Button></div>
                }
            }
        )
    }



    const drawText = (_arr) => {
        let _txt = "";
        _arr.map((item, index) => {
            return { key: index, title: item.title, eisbn: item.eisbn, isbn: item.isbn, status: item.success }
        }).forEach(itm => {
            let title = (itm.status !== false) ? itm.title : "* Title not found";
            _txt += itm.isbn + "       " + title + "\n";
        });
        return _txt;
    }

    const drawTable = () => {

        if (hasPermission && drag && (processed.length <= limit)) {
            return <DragTable callback={(arr) => {
                resetSort();
                updateList(arr.map(item => { return item.isbn }));
            }} rowKey={"isbn"} className="bc" scroll={{ y: 255 }} size="small" style={{ "border": "1px solid #eee" }} data={processed} setData={setProcessed} columns={columns} />
        }

        return (
            <Table loading={loading} rowKey={"isbn"} pagination={(processed.length <= limit) ? false : { pageSize: limit, showSizeChanger: false }} className="bc" scroll={{ y: 255 }} style={{ "border": "1px solid #eee" }} columns={columns} dataSource={processed} size="small"></Table>
        )
    }

    const generateFile = (_text, show_list = false, add = true) => {

        var filename = 'pasted.txt';
        let _file = new File([new Blob([_text])], filename)
        let f = {}
        f.file = _file;
        uploadFile(f, show_list, add);
    }

    const drawUpload = () => {
        return (
            <>
                <div style={{ "height": "296px" }}>
                    <Upload.Dragger accept=".txt, .pdf, .xls, .xlsx, .html, .csv" showUploadList={false} customRequest={(e) => uploadFile(e)} style={{ "padding": "0px 20px", "height": "300px" }}>
                        <div >
                            {(uploading) ? <Spin style={{ height: "35px" }} /> : <UploadOutlined style={{ "fontSize": "30px", height: "35px" }} />}
                        </div>
                        <p className="ant-upload-text">Click or drag to upload</p>
                        <p className="ant-upload-hint">
                            Upload an Excel file (.xls or .xlsx) or tab delimited (.txt) with the header "isbn"
                        </p>
                    </Upload.Dragger>
                </div>
            </>
        )
    }

    const drawProcess = () => {
        return (
            <>
                {drawTable()}
            </>
        )
    }


    const addIsbns = (_isbns) => {
        apiCall("titlelist/addIsbns", { list_id: list_id, isbns_json: JSON.stringify(_isbns) }, (_s, _r) => {
            if (_s) {
                updateRow(_r);
                setProcessed(_r.isbns);
                message.success("ISBNs added.")
            } else {
                message.error(_r.error);
            }
        })

    }

    const replaceIsbns = (_isbns) => {
        apiCall("titlelist/replaceIsbns", { list_id: list_id, isbns_json: JSON.stringify(_isbns) }, (_s, _r) => {
            if (_s) {
                updateRow(_r);
                setProcessed(_r.isbns);
                message.success("ISBNs replaced.");
            } else {
                message.error(_r.error);
            }
        })
    }


    const drawExtra = () => {
        if (hasPermission) { return (<></>) }
        return (
            <Space>
                <Overlay width={600} component={<ListAddReplace onComplete={(_f) => generateFile(_f, false, true)} />}><Button ghost type="primary" size="small"><small>Add ISBNs</small></Button></Overlay>
                {(list_id && <Overlay width={530} component={<ListAddReplace onComplete={(_f) => replaceIsbns(_f)} />}><Button ghost type="primary" size="small"><small>Replace All</small></Button></Overlay>)}
            </Space>
        )

    }

    return (
        <>

            <Tabs tabBarExtraContent={drawExtra()} className="itemTabs" onChange={(e) => setPosition(e)} size="small" activeKey={position} type="card" >
                <Tabs.TabPane tab="List" key="list">
                    {drawProcess()}
                </Tabs.TabPane>

                {((hasPermission) &&
                    <Tabs.TabPane tab="Text" key="text">
                        <Spin spinning={(uploading)}>
                            <Form form={form}>
                                <Form.Item name="txt" noStyle>
                                    <Input.TextArea style={{ "fontFamily": "ApercuMono" }} onFocus={() => setCanSave(false)} onBlur={(e) => generateFile(e.target.value)} placeholder={placeholder} defaultValue={drawText(processed)} rows={13} />
                                </Form.Item>
                            </Form>

                            <div className="shim" />
                            <div style={{ "float": "right" }}><Button disabled={(canSave)} type="primary" size="small"><small>Update</small></Button></div>
                            <br clear="all" />
                        </Spin>
                    </Tabs.TabPane>
                )}
                {((hasPermission) &&
                    <Tabs.TabPane tab="Import" key="import">
                        {drawUpload()}
                    </Tabs.TabPane>
                )}
            </Tabs>

        </>
    )

}